if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/nodelist-foreach-polyfill/index.js
// module id = 992
// module chunks = 32